import {gql} from '@apollo/client';

export default gql`
  fragment DynamicApproval on DynamicApprovalObject {
    id
    requestedAt
    updatedAt
    state
    comment
    campaignDynamic {
      id
    }
    updatedBy {
      email
    }
    requestedBy {
      id
      firstName
      lastName
      email
    }
    requestedByOrganization {
      id
      name
    }
    requestee {
      id
      firstName
      lastName
      email
    }
    requesteeOrganization {
      id
      name
    }
    rejectedReason
  }
`;
